import React, { useState, useEffect } from 'react';
import { getStatsOverview, getDailyStats, getTopUsers } from './adminApi';
import './Stats.css';

const Stats = () => {
  const [loading, setLoading] = useState(true);
  const [overview, setOverview] = useState(null);
  const [dailyStats, setDailyStats] = useState([]);
  const [topUsers, setTopUsers] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [overviewData, dailyData, topUsersData] = await Promise.all([
        getStatsOverview({}),
        getDailyStats(30),
        getTopUsers(10)
      ]);
      setOverview(overviewData);
      setDailyStats(dailyData);
      setTopUsers(topUsersData);
    } catch (err) {
      console.error('获取统计数据失败:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-spinner"></div>
      </div>
    );
  }

  const maxDailyDocs = Math.max(...dailyStats.map(d => d.documents), 1);

  return (
    <div className="stats-page">
      <h2 className="page-title">数据统计</h2>

      {/* 概览卡片 */}
      <div className="stat-cards">
        <div className="stat-card">
          <div className="stat-card-title">用户总数</div>
          <div className="stat-card-value">{overview?.users?.total || 0}</div>
          <div className="stat-card-footer">
            统计期内新增: {overview?.users?.new_in_period || 0}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-title">登录次数</div>
          <div className="stat-card-value">{overview?.logins?.in_period || 0}</div>
          <div className="stat-card-footer">
            失败: {overview?.logins?.failed_in_period || 0}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-title">公文排版</div>
          <div className="stat-card-value">{overview?.documents?.document?.in_period || 0}</div>
          <div className="stat-card-footer">
            累计: {overview?.documents?.document?.total || 0}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-title">行程排版</div>
          <div className="stat-card-value">{overview?.documents?.schedule?.in_period || 0}</div>
          <div className="stat-card-footer">
            累计: {overview?.documents?.schedule?.total || 0}
          </div>
        </div>
      </div>

      <div className="stats-row">
        {/* 每日趋势 */}
        <div className="admin-card trend-card">
          <div className="admin-card-header">
            <h3 className="admin-card-title">近30天趋势</h3>
          </div>
          <div className="trend-chart-wrapper">
            <div className="trend-chart">
              {dailyStats.slice(-15).map((item, index) => (
                <div key={index} className="trend-bar-wrapper">
                  <div 
                    className="trend-bar" 
                    style={{ 
                      height: `${Math.max(item.documents / maxDailyDocs * 150, 4)}px` 
                    }}
                  >
                    <span className="trend-value">{item.documents}</span>
                  </div>
                  <div className="trend-label">{item.date.slice(5)}</div>
                </div>
              ))}
            </div>
            <div className="trend-legend">
              <span className="legend-item">
                <span className="legend-dot" style={{ background: '#1890ff' }}></span>
                文档生成数
              </span>
            </div>
          </div>
        </div>

        {/* 活跃用户排行 */}
        <div className="admin-card">
          <div className="admin-card-header">
            <h3 className="admin-card-title">活跃用户 TOP10</h3>
          </div>
          <table className="admin-table">
            <thead>
              <tr>
                <th>排名</th>
                <th>用户</th>
                <th>生成文档数</th>
              </tr>
            </thead>
            <tbody>
              {topUsers.map((item, index) => (
                <tr key={item.user.id}>
                  <td>
                    <span className={`rank-badge rank-${index + 1}`}>
                      {index + 1}
                    </span>
                  </td>
                  <td>{item.user.username}</td>
                  <td>{item.document_count}</td>
                </tr>
              ))}
              {topUsers.length === 0 && (
                <tr>
                  <td colSpan="3" className="admin-empty">暂无数据</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* 详细数据表格 */}
      <div className="admin-card">
        <div className="admin-card-header">
          <h3 className="admin-card-title">每日详细数据</h3>
        </div>
        <div className="table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>日期</th>
                <th>新用户</th>
                <th>登录次数</th>
                <th>公文排版</th>
                <th>行程排版</th>
                <th>台签排版</th>
                <th>单位排版</th>
                <th>文档总计</th>
              </tr>
            </thead>
            <tbody>
              {dailyStats.map((item, index) => (
                <tr key={index}>
                  <td>{item.date}</td>
                  <td>{item.new_users}</td>
                  <td>{item.logins}</td>
                  <td>{item.documents}</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><strong>{item.documents}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Stats;
